import { MagicConfigMixin, interpolate } from '@gig/magic-common';
import { Mixins, Prop, Emit, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let TextComponent = class extends Mixins(MagicConfigMixin) {
  get processedText() {
    let interpolateParams = this.magicConfig.interpolationParams;
    if (this.params) {
      interpolateParams = __spreadValues(__spreadValues({}, interpolateParams), this.params);
    }
    return interpolate(this.content || "", interpolateParams, this.isMarkdown);
  }
  updated() {
    this.onTextLoad();
  }
  onTextLoad() {
    return;
  }
};
__decorateClass([
  Prop(String)
], TextComponent.prototype, "content", 2);
__decorateClass([
  Prop(String)
], TextComponent.prototype, "unsafeContent", 2);
__decorateClass([
  Prop(Boolean)
], TextComponent.prototype, "isMarkdown", 2);
__decorateClass([
  Prop(Object)
], TextComponent.prototype, "params", 2);
__decorateClass([
  Prop(String)
], TextComponent.prototype, "tag", 2);
__decorateClass([
  Prop(Boolean)
], TextComponent.prototype, "offerText", 2);
__decorateClass([
  Prop(Boolean)
], TextComponent.prototype, "promotionText", 2);
__decorateClass([
  Prop(Boolean)
], TextComponent.prototype, "landingPageText", 2);
__decorateClass([
  Prop(Boolean)
], TextComponent.prototype, "contentText", 2);
__decorateClass([
  Prop(Boolean)
], TextComponent.prototype, "carouselText", 2);
__decorateClass([
  Prop(Boolean)
], TextComponent.prototype, "marketingBannerText", 2);
__decorateClass([
  Prop(Boolean)
], TextComponent.prototype, "noInheritance", 2);
__decorateClass([
  Prop(Boolean)
], TextComponent.prototype, "inheritWeight", 2);
__decorateClass([
  Prop(Boolean)
], TextComponent.prototype, "ellipsis", 2);
__decorateClass([
  Prop(Boolean)
], TextComponent.prototype, "primary", 2);
__decorateClass([
  Emit("textLoad")
], TextComponent.prototype, "onTextLoad", 1);
TextComponent = __decorateClass([
  Component({
    name: "ui-text"
  })
], TextComponent);

export default TextComponent;
